import { EnvConfig } from '@config';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const FEEDBACK_EVENT_PREFIX = 'FEEDBACK_';
export const LESSON_LEARNT_APPROVED_EVENT = 'LESSON_LEARNT_APPROVED';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: EnvConfig.instrumentationKey,
    enableAutoRouteTracking: true,
    maxBatchInterval: 0,
    disableFetchTracking: false,
  },
});
appInsights.loadAppInsights();

export const setAuthenticatedUser = (authenticatedUserId: string, accountId: string) => {
  console.log(
    '---setAuthenticatedUser function has been called---',
    authenticatedUserId,
    accountId,
  );

  appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, true);
};

export const loadedAppInsights = appInsights;
